import React, { useState, useMemo } from "react";
import "./Allproduct2.css";
import Adobe from "../../assest/products/adobe.jpg";
import Autocad from "../../assest/products/autocad.jpg";
import Microsoft from "../../assest/products/microsoft.jpg";
import Oracle from "../../assest/products/oracle.jpg";
import Redhat from "../../assest/products/redhat.jpg";
import Symantec from "../../assest/products/symantec.jpg";
import Solarwind from "../../assest/products/solarwind.jpg";
import Trend from "../../assest/products/trend.jpg";
import Veeam from "../../assest/products/veeam.jpg";
import Vmware from "../../assest/products/vmware.jpg";
import Bitdefender from "../../assest/products/bitdefender.jpg";
import Crowdstrike from "../../assest/products/crowdstrike.jpg";
import Delinea from "../../assest/products/delinea.jpg";
import Elasticsearch from "../../assest/products/elasticsearch.jpg";
import Gitlab from "../../assest/products/gitlab.jpg";
import Katalon from "../../assest/products/katalon.jpg";
import Lansweeper from "../../assest/products/lansweeper.jpg";
import RidgeSecurity from "../../assest/products/ridge security banner.jpg";
import Tenable from "../../assest/products/tenable.jpg"; 

const Software = () => {
  const [selectedLetter, setSelectedLetter] = useState("All");
 
  const products = useMemo(
    () => ({
      A: [
        {
          name: "Adobe",
          category: "All Applications",
          logo: Adobe,
          link: "https://www.adobe.com",  
        },
        {
          name: "Autocad",
          category: "3D",
          logo: Autocad,
          link: "https://www.autodesk.com/products/autocad/overview",  
        },
      ],
      B: [
        {
          name: "Bitdefender",
          category: "Security",
          logo: Bitdefender,
          link: "https://www.bitdefender.com",
        },
      ],
      C: [
        {
          name: "Crowdstrike",
          category: "Security",
          logo: Crowdstrike,
          link: "https://www.crowdstrike.com",  
        },
      ],
      D: [
        {
          name: "Delinea",
          category: "Privilege Access Management",
          logo: Delinea,
          link: "https://delinea.com",  
        },
      ],
      E: [
        {
          name: "Elasticsearch",
          category: "Log and Search",
          logo: Elasticsearch,
          link: "https://www.elastic.co/elasticsearch",  
        },
      ],
      G: [
        {
          name: "Gitlab",
          category: "DevSecOps",
          logo: Gitlab,
          link: "https://about.gitlab.com",
        },
      ],
      K: [
        {
          name: "Katalon",
          category: "Automate Testing",
          logo: Katalon,
          link: "https://www.katalon.com",  
        },
      ],

      L: [
        {
          name: "Lansweeper",
          category: "Asset and Monitoring",
          logo: Lansweeper,
          link: "https://www.linksys.com/th/",  
        },
      ],
      M: [
        {
          name: "Microsoft",
          category: "MS Windows & MS Applications",
          logo: Microsoft,
          link: "https://www.microsoft.com/th-th",  
        },
      ],
      O: [
        {
          name: "Oracle",
          category: "Database Leader & Middleware",
          logo: Oracle,
          link: "https://www.oracle.com/th/",  
        },
      ],
      R: [
        {
          name: "Ridge Security",
          category: "Automate Penetration Test",
          logo: RidgeSecurity,
          link: "https://www.ridgesecurity.com", 
        },
        {
          name: "Red hat",
          category: "Number 1 Open Source Company",
          logo: Redhat,
          link: "https://www.redhat.com/th",  
        },
      ],
      S: [
        {
          name: "Symantec",
          category: "Data Protection and Security",
          logo: Symantec,
          link: "https://www.broadcom.com/company/newsroom/press-releases?filtr=Symantec", 
        },

        {
          name: "SolarWinds",
          category: "Network & System Monitoring",
          logo: Solarwind,
          link: "https://www.solarwinds.com/",  
        },
      ],
      T: [
        {
          name: "Tenable",
          category: "VA Scan",
          logo: Tenable,
          link: "https://www.tenable.com",  
        },

        {
          name: "Trend",
          category: "Antivirus",
          logo: Trend,
          link: "https://www.trendmicro.com", 
        },
      ],
      V: [
        {
          name: "Veeam",
          category: "Backup & DR for Virtualization",
          logo: Veeam,
          link: "https://www.veeam.com/",  
        },
        {
          name: "Vmware",
          category: "The Best Virtualization Software",
          logo: Vmware,
          link: "https://www.vmware.com/",  
        },
      ],
    }),
    []
  );

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
  };

  const filteredProducts =
    selectedLetter === "All"
      ? Object.values(products).flat() 
      : products[selectedLetter] || [];

  return (
    <div className="product-page-container">
      <div className="product-introduction">
        <h1>Software Products</h1>
        <div className="product-categories">
          <div className="category-header">
            <h2>A-Z</h2>
          </div>
        </div>
      </div>

      <div className="all-product-container">
        <div className="alphabet-selector">
          {["All", ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")].map((letter) => (
            <span
              key={letter}
              className={`alphabet ${
                letter === selectedLetter ? "active" : ""
              }`}
              onClick={() => handleLetterClick(letter)}
            >
              {letter}
            </span>
          ))}
        </div>
        <div className="product-list">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product, index) => (
              <a
                key={index}
                href={product.link}
                target="_blank"
                rel="noopener noreferrer"
                className="product-item"
              >
                <img
                  src={product.logo}
                  alt={product.name}
                  className="product-logo"
                />
                <p>{product.name}</p>
                <p className="product-category">{product.category}</p>
              </a>
            ))
          ) : (
            <p className="no-products">
              No products available for this letter.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Software;
